<template lang="pug">
ul.links
  li(
    v-for="(link, index) in menuJP.MenuList",
    :key="index",
    :class="{ selected: checkSelect(link.PageJson) }"
  )
    router-link(
      tag="a",
      :to="{ name: 'Japanese', params: { page: link.PageJson } }"
    ) {{ link.MenuTitle }}
</template>
<script>
import { getMenuJP } from "@/json/menu";

export default {
  name: "Links",
  data() {
    return {
      menuJP: {},
    };
  },
  created() {
    this.getMenuJP();
  },
  methods: {
    getMenuJP() {
      getMenuJP().then((response) => {
        this.menuJP = response.data;
        this.$router.push({
          name: "Japanese",
          params: {
            page: this.menuJP.MenuList[0].PageJson,
          },
        });
      });
    },
    checkSelect(NAME) {
      if (NAME == this.$route.params.page) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/lang/link";
</style>
